const dropzoneLocale = {
  dropzone: {
    dropFilesHere: "Déposez les fichiers ici ...",
    dragndrop: "Glissez-déposez des fichiers ici, ou cliquez pour sélectionner des fichiers",
    authorizedTypes: "Fichiers autorisés: {types}",
    sizeMax: "Taille maximale: {size}",
    errors: {
      fileInvalidType: "Type de fichier invalide. Veuillez sélectionner un type de fichier valide.",
      fileTooLarge: "Fichier trop volumineux. Veuillez sélectionner un fichier plus petit.",
      fileTooSmall: "Fichier trop petit. Veuillez sélectionner un fichier plus grand.",
      tooManyFiles: "Trop de fichiers sélectionnés. Veuillez sélectionner un nombre plus restreint de fichiers.",
      unknown: "Une erreur inconnue s'est produite lors du traitement du fichier.",
    },
  },
};

export type DropzoneLocale = typeof dropzoneLocale;
export default dropzoneLocale;
